module.exports = __webpack_public_path__ + "pc/img/blue-painting.bb381ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/blue-painting.png
// module id = IeK6
// module chunks = 3